/** marks a MINI pizza where MINI ones stand among the others */
export function MiniBadge() {
  return <span className="shrink-0 rounded-full bg-amber-400/15 px-2 py-0.5 text-xs font-bold tracking-wide text-amber-300">MINI</span>;
}
